module.exports = __webpack_public_path__ + "img/waves_tl.d5b28627.png";